module.exports = __webpack_public_path__ + "static/media/SellerboxFunction01.0d24aa75.png";